import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { BulkSendsHistoryPage, BULK_SENDS_HISTORY_FILTERS, type BulkSendsHistoryFilter, type BulkSendsHistorySearch } from '@/features/marketing';
import { formatDocumentTitle } from '@/lib/document-title';

/**
 * Marketing › Texts & Emails — `/marketing/bulk-sms`: every past bulk text and email. Each send's own screen stays at
 * `/marketing/bulk-sms/{id}` (a sibling route, not nested in this page).
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/bulk-sms')({
  validateSearch: (search: Record<string, unknown>): BulkSendsHistorySearch => ({
    channel: BULK_SENDS_HISTORY_FILTERS.find((filter): filter is BulkSendsHistoryFilter => filter === search.channel),
  }),
  component: BulkSendsHistoryRoute,
});

function BulkSendsHistoryRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/bulk-sms' });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Texts & Emails', 'Marketing')}</title>
      </Helmet>
      {/* The filter replaces the history entry: Back leaves the page instead of stepping through filters. */}
      <BulkSendsHistoryPage orgId={orgId} search={search} onChangeSearch={(next) => void navigate({ search: next, replace: true })} />
    </>
  );
}
